import RoleHome from '../../components/RoleHome/RoleHome';
export default function LogistHome() {
  return <RoleHome role="logist" />;
}